import React from 'react';
import intl from 'react-intl-universal';
import AuthActions from '../actions/AuthActions';
import AuthStore from '../stores/AuthStore';
import { withRouter } from 'react-router-dom';

class HeaderComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated(),
      name: AuthStore.getUser().name,
      pakowalnia_name: AuthStore.getPakowalniaName()
    }
    this.logout = this.logout.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  logout() {
    AuthActions.logUserOut();
  }

  componentWillMount() {
    AuthStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthStore.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      authenticated: AuthStore.isAuthenticated(),
      name: AuthStore.getUser().name,
      pakowalnia_name: AuthStore.getPakowalniaName()
    });
  }

  render() {
    return (
      <header>
        <div className="logo"/>
        { this.state.authenticated ? (
          <div className="nav">
            <div className="auth_info">
              <span className="auth_info_name">
                <svg aria-hidden="true" data-prefix="fas" data-icon="user" className="svg-inline--fa fa-user fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg>
                { this.state.name }
              </span>
              <span className="auth_info_pakowalnia">
                <svg aria-hidden="true" data-prefix="fas" data-icon="cube" className="svg-inline--fa fa-cube fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"></path></svg>
                { this.state.pakowalnia_name }
              </span>
            </div>
            <a role="button" className="logout" onClick={this.logout}>{intl.get('Wyloguj')}</a>
          </div>
        ):''}
      </header>
    );
  }
}

export default withRouter(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/Header.js